import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import cssclass from "./cssclass";
import { useNavigate } from 'react-router-dom'

//this page should replace lbrclrresponse.  Also see wptappscan


const RenderWpForm = () => {

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");	
const scansurl=sessionStorage.getItem("SCANSURL");	


//var boolFetchingSads=false;

const navigate = useNavigate();


const [dowait, setDowait] = useState({show:false});
const [TOTAL_EMPTY_FIELDS, setTOTAL_EMPTY_FIELDS] = useState({NUM:500});

const [wptapp, setWptapp] = useState({WPT_APP_ID:0});
const [axiofl, setAxiofl] = useState({selectedFile: null});
const [uploadfile, setUploadfile] = useState({name:""});
const [progress, setProgress] = useState({
perct:null
});

const location = useLocation();


useEffect(() => {
	
const USERNAME = sessionStorage.getItem("USERNAME")??"";
	
if (USERNAME==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "Pdf Documents";	


var opener = window.opener;
if(opener) {
    var oDom = opener.document;
    var elem = oDom.getElementsByName("pdf_url")[0];
    if (elem) {
        const pdf_url = elem.value;
		console.log("pdf_url: "+pdf_url);
		document.getElementById("embed1").src=pdf_url;
		}
	else
		window.alert("path to pdf file was not received");
	}//end if
else{
	//navigate("/");
	window.close();
	return;
	}//end if	


 },[]);



function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func
	

  return (
    <>

		<div align="center">
		<embed id="embed1"
			/*src="https://customsprem.gov.tc/webuploads/currdoc/Notice%20Of%20Auction%20-%20Providenciales%20Auction%20List%202021.pdf#toolbar=0&navpanes=0&scrollbar=0"*/
			src=""
			type="application/pdf"
			frameBorder="0"
			scrolling="auto"
			height="800"
			width="98%"
			
		></embed>
		</div>
					




<div id="snackbar">&nbsp;</div>
    </>
  );
  


};


export default RenderWpForm;